import { Fragment, useState, useEffect, useCallback } from "react";
import BlackScholesCalculator from "./BlackscholesCalculator";
import Calculator from "./Calculator";
import getUrl from "../../tools/get-domain";

export default function CalculatorsPage() {
    const [activeTab, setActiveTab] = useState("blackscholes");
    const [inputFields, setInputFields] = useState({
        longCall: [],
        shortCall: [],
        longPut: [],
        shortPut: [],
    });

    const tabs = [
        {
            id: 1,
            title: "بلک شولز",
            key: "blackscholes",
            component: <BlackScholesCalculator />,
        },
        {
            id: 2,
            title: "long-call",
            key: "long-call",
            component: (
                <Calculator
                    inputFields={inputFields.longCall}
                    strategyName="long-call"
                />
            ),
        },
        {
            id: 3,
            title: "short-call",
            key: "short-call",
            component: (
                <Calculator
                    inputFields={inputFields.shortCall}
                    strategyName="short-call"
                />
            ),
        },
        {
            id: 4,
            title: "long-put",
            key: "long-put",
            component: (
                <Calculator
                    inputFields={inputFields.longPut}
                    strategyName="long-put"
                />
            ),
        },
        {
            id: 5,
            title: "short-put",
            key: "short-put",
            component: (
                <Calculator
                    inputFields={inputFields.shortPut}
                    strategyName="short-put"
                />
            ),
        },
    ];

    const fetchData = async (strategyName) => {
        const url = `${
            getUrl().REACT_APP_STRATEGY_CALCULATOR
        }${strategyName}?data=True`;

        const response = await fetch(url, {
            method: "GET",
            credentials: "include",
        });

        const data = await response.json();
        return data.data;
    };

    const fetchLongCallData = useCallback(async () => {
        const data = await fetchData("long-call");
        setInputFields((prev) => {
            return { ...prev, longCall: data };
        });
    }, []);

    const fetchShortCallData = useCallback(async () => {
        const data = await fetchData("short-call");
        setInputFields((prev) => {
            return { ...prev, shortCall: data };
        });
    }, []);

    const fetchLongPutData = useCallback(async () => {
        const data = await fetchData("long-put");
        setInputFields((prev) => {
            return { ...prev, longPut: data };
        });
    }, []);

    const fetchShortPutData = useCallback(async () => {
        const data = await fetchData("short-put");
        setInputFields((prev) => {
            return { ...prev, shortPut: data };
        });
    }, []);

    useEffect(() => {
        fetchLongCallData();
        fetchShortCallData();
        fetchLongPutData();
        fetchShortPutData();
    }, [
        fetchLongCallData,
        fetchShortCallData,
        fetchLongPutData,
        fetchShortPutData,
    ]);

    return (
        <div className="tw-container tw-mx-auto tw-p-4 md:tw-p-10">
            <h1 className="tw-mb-10">ماشین حساب های اختیار معامله</h1>
            <div className="tw-bg-gray-50 tw-p-4 md:tw-p-10 tw-shadow-lg tw-rounded-lg">
                <div className="tw-flex tw-items-center tw-justify-center tw-mb-6">
                    <div className="tw-flex tw-items-center tw-gap-4 tw-shadow-lg tw-px-4 tw-py-2 tw-rounded-md tw-border tw-border-gray-100">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                type="button"
                                className={`${
                                    tab.key === activeTab &&
                                    "tw-py-2 tw-px-4 tw-text-sm tw-border tw-rounded-lg"
                                }`}
                                style={{
                                    boxShadow:
                                        tab.key === activeTab &&
                                        "inset 2px 5px 4px rgba(0, 0, 0, 0.1)",
                                }}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.title}
                            </button>
                        ))}
                    </div>
                </div>
                {tabs.map(
                    (tab) =>
                        tab.key === activeTab && (
                            <Fragment key={tab.id}>{tab.component}</Fragment>
                        )
                )}
            </div>
        </div>
    );
}
